import { lazy } from 'react'

const MessagingComponent = lazy(async () => {
  const { Messages } = await import(/* webpackChunkName: "messaging" */ './index')

  return {
    default: Messages
  }
})
const routes = [
  {
    path: '/messaging',
    authenticated: true,
    render(props) {
      return <MessagingComponent {...props} />
    }
  }
]

export { routes }
